(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.Events.AncillaryPlanningEvent",
                    {
                        url: "/AncillaryPlanningGroup/:EventGroupId/Event/:EventId",
                        component: "planningEvent",
                        PageTitle: "Event Details | Marketing Tracker"
                    })
                .state("Home.Tools.MarketingTrackerNew.Events.PlanningEvent",
                    {
                        url: "/PlanningGroup/:EventGroupId/Event/:EventId",
                        component: "planningEvent",
                        PageTitle: "Event Details | Marketing Tracker"
                    });
        }
    ]);

    app
        .component("planningEvent",
            {
                templateUrl: "App/Tools/MarketingTrackerNew/Events/PlanningEventView/planningevent-view-template.html",
                controller: planningEventController,
                bindings: {
                }
            });

    planningEventController.$inject = ["$mdDialog", "marketingTrackerEventGroupApi", "marketingTrackerEventApi", "marketingTrackerAncillaryEventGroupApi", "$state", "$stateParams", "$timeout", "figToaster"];
    function planningEventController($mdDialog, marketingTrackerEventGroupApi, marketingTrackerEventApi, marketingTrackerAncillaryEventGroupApi, $state, $stateParams, $timeout, figToaster) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    saving: false,
                    deleting: false
                },
                isAncillary: $state.$current.name.split(".", 5)[4] === "AncillaryPlanningEvent" ? true : false,
                checkChanged: checkChanged,
                deleteEvent: deleteEvent,
                hasSaved: false,
                showSavedMessage: showSavedMessage,
                saveViaKeyboard: saveViaKeyboard,
                update: update
            });

        function checkChanged() {
            if (!ng.equals($ctrl.eventGroup, $ctrl.eventGroupCopy) || !ng.equals($ctrl.event, $ctrl.eventCopy))
                return false;
            else return true;
        }

        function deleteEvent($event) {
            var message = "", toastClass = "";
            var confirm = $mdDialog.confirm({
                title: "Are you sure you want to delete this event?",
                targetEvent: $event,
                ariaLabel: "Confirm event removal",
                ok: "Yes",
                cancel: "No",
                multiple: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(confirm).then(function () {
                $ctrl.ui.deleting = true;
                if (!$ctrl.isAncillary) {
                    return marketingTrackerEventGroupApi.deleteEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                        .then(function () {
                            //$state.go("Home.Tools.MarketingTrackerNew.Calendar.CalendarView");                        
                            $state.go("Home.Tools.MarketingTrackerNew.Events.EventListView");
                            message = "Event deleted.";
                            toastClass = "is-success";
                            return $mdDialog.hide({
                                eventGroupId: $ctrl.eventGroup.Id,
                                eventId: $ctrl.event.Id,
                                toDelete: true
                            });
                        })
                        .catch(function (error) {
                            console.log("Error: " + error.data);
                            message = "There was a problem deleting your event. Please try again shortly.";
                            toastClass = "is-error";
                        })
                        .finally(function () {
                            $ctrl.ui.deleting = false;
                            return figToaster.showSimple(message, "top", toastClass);
                        });
                }
                return marketingTrackerAncillaryEventGroupApi.deleteAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id)
                    .then(function () {
                        $state.go("Home.Tools.MarketingTrackerNew.Events.EventListView");
                        message = "Event deleted.";
                        toastClass = "is-success";
                        return $mdDialog.hide({
                            eventGroupId: $ctrl.eventGroup.Id,
                            eventId: $ctrl.event.Id,
                            toDelete: true
                        });
                    })
                    .catch(function (error) {
                        console.log("Error: " + error.data);
                        message = "There was a problem deleting your event. Please try again shortly.";
                        toastClass = "is-error";
                    })
                    .finally(function () {
                        $ctrl.ui.deleting = false;
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            });
        }

        function saveViaKeyboard($event) {
            if (event.ctrlKey && event.keyCode === 83) {
                event.preventDefault();
                update();
            }
        }
        function showSavedMessage() {
            $ctrl.hasSaved = true;
            $timeout(function () {
                $ctrl.hasSaved = false;
            }, 3000);
        }

        function update() {
            $ctrl.ui.saving = true;
            var message = "", toastClass = "";

            if (!$ctrl.isAncillary) {
                marketingTrackerEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup)
                    .then(function () {
                        marketingTrackerEventGroupApi.updateEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event)
                            .then(function () {
                                showSavedMessage();
                            });
                        message = "Changes saved.";
                        toastClass = "is-success";
                    })
                    .catch(function (error) {
                        console.log("Error: " + error.data);
                        message = "There was a problem updating your event. Please try again shortly.";
                        toastClass = "is-error";
                    })
                    .finally(function () {
                        $ctrl.ui.isUploading = false;
                        $ctrl.ui.saving = false;
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            } else {
                marketingTrackerAncillaryEventGroupApi.update($ctrl.eventGroup.Id, $ctrl.eventGroup)
                    .then(function () {
                        marketingTrackerAncillaryEventGroupApi.updateAncillaryEvent($ctrl.eventGroup.Id, $ctrl.event.Id, $ctrl.event)
                            .then(function () {
                                showSavedMessage();
                            });
                        message = "Changes saved.";
                        toastClass = "is-success";
                    })
                    .catch(function (error) {
                        console.log("Error: " + error.data);
                        message = "There was a problem updating your event. Please try again shortly.";
                        toastClass = "is-error";
                    })
                    .finally(function () {
                        $ctrl.ui.saving = false;
                        $ctrl.ui.isUploading = false;
                        return figToaster.showSimple(message, "top", toastClass);
                    });
            }
        }

        $ctrl.$onInit = function () {
            if (!$ctrl.isAncillary) {
                marketingTrackerEventApi.getEvent($stateParams.EventGroupId, $stateParams.EventId)
                    .then(function (response) {
                        $ctrl.event = response;
                        $ctrl.event.EventDate = new Date($ctrl.event.EventDate);
                        $ctrl.eventCopy = ng.copy($ctrl.event);
                    });
                marketingTrackerEventApi.getEventGroup($stateParams.EventGroupId)
                    .then(function (response) {
                        $ctrl.eventGroup = response;
                        $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                    });
            } else {
                marketingTrackerEventApi.getAncillaryEvent($stateParams.EventGroupId, $stateParams.EventId)
                    .then(function (response) {
                        $ctrl.event = response;
                        $ctrl.event.EventDate = new Date($ctrl.event.EventDate);
                        $ctrl.eventCopy = ng.copy($ctrl.event);
                    });
                marketingTrackerEventApi.getAncillaryEventGroup($stateParams.EventGroupId)
                    .then(function (response) {
                        $ctrl.eventGroup = response;
                        $ctrl.eventGroupCopy = ng.copy($ctrl.eventGroup);
                    });
            }
        };
    }

})(window.app, window.angular); //jshint ignore:line